"use client";

import React from "react";
import GSTSearchSimulation from "../../components/GSTSearchSimulation";

export default function GSTSearchPage() {
  return (
    <div>
      <GSTSearchSimulation />
    </div>
  );
}
